import { SetStateAction } from 'react'
import { MAKE, MANUFACTURER, MODEL } from '../constants/filter.constants'
import { AssetType } from '../types/bucketTypes'

interface FilterType {
    category: string
    type: {
        title: string
        checked: boolean
    }[]
}

export const getFilters = (assets: AssetType[]) => {
    let make: string[] = []
    let manufacturer: string[] = []
    let model: string[] = []

    assets.forEach((value, i) => {
        make[i] = value.bucket[MAKE] as string
        manufacturer[i] = value.bucket[MANUFACTURER] as string
        model[i] = value.bucket[MODEL] as string
    })

    make = [...new Set(make)]
    manufacturer = [...new Set(manufacturer)]
    model = [...new Set(model)]

    const filters: SetStateAction<FilterType[]> = [
        {
            category: 'Make',
            type: make.map((item: string) => {
                return {
                    title: item,
                    checked: false,
                }
            }),
        },
        {
            category: 'Model',
            type: model.map((item: string) => {
                return {
                    title: item,
                    checked: false,
                }
            }),
        },
        {
            category: 'Manufacturer',
            type: manufacturer.map((item: string) => {
                return {
                    title: item,
                    checked: false,
                }
            }),
        },
    ]

    return filters
}
